import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Upload,
} from "antd";
import get from "lodash/get";
import moment from "moment";
import { connect } from "react-redux";

import { updateDrugRequest, uploadDrugRequest } from "../../api/requests";
import {
  getDrugCreatePermission,
  getDrugUpdatePermission,
  getUserTimezone,
  getUserShortTimezone,
  getDrugAccessPermissionDrugManagement,
  getDrugAllowEditItem,
  getDrugPackageInfoEditInDrugManagement,
  getDrugExpiryDateEditPermission,
} from "../../reducers/user/selectors";

import classes from "./DrugForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import {getFormErrorMessage} from "../../utils/errorHandler";

const { Option } = Select;

class DrugForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          if (this.props.id) {
            const drug = { ...values };
            drug.expiry_date = values.expiry_date.format('YYYY-MM-DD');

            await updateDrugRequest(this.props.id, drug);
          } else {
            const formData = new FormData();
            if (values.document_file && values.document_file.file) {
              formData.append("document_file", values.document_file.file);
            }
            // formData.append('location_id', values.location_id);
            await uploadDrugRequest(formData);
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: getFormErrorMessage(e, true),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      drugUpdatePermission,
      drugCreatePermission,
      drugAccessPermissionDrugManagement,
      id,
      isNew,
      drugAllowEditItem,
    } = this.props;

    const isEditable = id ? drugUpdatePermission : drugCreatePermission;

    const isEditableDrugType =
      (id ? drugUpdatePermission : drugCreatePermission) && drugAllowEditItem;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {isNew
              ? this.props.i18n.t("NamespaceDrugForm:Upload drugs")
              : this.props.i18n.t("Edit")}
          </h4>

          {!id && (
            <Row gutter={12}>
              <Col md={12}>
                <b>{this.props.i18n.t("Select .csv")}</b>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                  })(
                    <Upload
                      disabled={!isEditable}
                      accept=".csv"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.url
                          ? this.props.i18n.t("Change file")
                          : this.props.i18n.t("NamespaceDrugForm:Upload drugs")}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>

                {!this.props.form.getFieldValue("document_file") &&
                  this.props.url && (
                    <div>
                      <a href={this.props.url} target="_blank">
                        {this.props.url}
                      </a>
                      <br />
                      <br />
                    </div>
                  )}
              </Col>

              {/*<Col md={12}>
              <label>
                <b>Storage id:</b>
                <Form.Item>
                  {getFieldDecorator('location_id', {
                    rules: [{ required: true, message: 'Required' }]
                  })(
                    <Select placeholder='Select'>
                      {map(sitesList, ({ value, label }) => (
                        <Option key={value} value={value}>{label}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>*/}

              <Col md={24}>
                {this.props.i18n.t(".CSV example")}:{" "}
                <a href="/drugs_example.csv" download>
                  <Button type="primary" size="small" htmlType="button">
                    {this.props.i18n.t("Download")}
                  </Button>
                </a>
                <br />
                <br />
              </Col>
            </Row>
          )}

          {id && (
            <Row gutter={12}>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceDrugForm:Drug #")}</b>
                  <Form.Item>
                    <Input
                      disabled={true}
                      value={get(this.props, "vial_number")}
                    />
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("Location")}</b>
                  <Form.Item>
                    <Input
                      disabled={true}
                      value={get(this.props, "location.name")}
                    />
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceDrugForm:Expiry date")}</b>
                  <Form.Item>
                    {getFieldDecorator("expiry_date", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "expiry_date")
                        ? moment(get(this.props, "expiry_date"))
                        : null,
                    })(
                      <DatePicker
                        disabled={!isEditable}
                        placeholder="yyyy-mm-dd"
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("Active ingredient dose")}</b>
                  <Form.Item>
                    {getFieldDecorator("active_ingredient_dose", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "active_ingredient_dose"),
                    })(
                      <Input
                        disabled={!isEditable || !this.props.drugPackageInfoEditInDrugManagement}
                        addonAfter="mg"
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceDrugForm:Units per package")}</b>
                  <Form.Item>
                    {getFieldDecorator("units_per_package", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "units_per_package"),
                    })(
                      <Input
                        disabled={!isEditable || !this.props.drugPackageInfoEditInDrugManagement}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12} />
              {drugAccessPermissionDrugManagement && (
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("NamespaceDrugForm:Drug type")}</b>
                    <Form.Item>
                      {getFieldDecorator("drug_type", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                        initialValue: get(this.props, "drug_type"),
                      })(
                        <Select disabled={!isEditableDrugType}>
                          <Option value="control">
                            {this.props.i18n.t("NamespaceDrugForm:Control")}
                          </Option>
                          <Option value="active_drug">
                            {this.props.i18n.t("NamespaceDrugForm:Active drug")}
                          </Option>
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>
              )}
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceDrugForm:Drug status")}</b>
                  <Form.Item>
                    {getFieldDecorator("drug_status", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "drug_status"),
                    })(
                      <Select disabled={true}>
                        <Option value="ready_to_dispense" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Ready to transfer from the manufacturer"
                          )}
                        </Option>
                        <Option value="in_transit_manufacturer_depot" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:In transit to the depot"
                          )}
                        </Option>
                        <Option value="received_by_depot" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Received by the depot"
                          )}
                        </Option>
                        <Option value="in_transit_depot_pharmacy" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:In transit to the pharmacy"
                          )}
                        </Option>
                        <Option value="received_by_pharmacy" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Received by pharmacy"
                          )}
                        </Option>
                        <Option value="quarantined" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Quarantined - Automatically"
                          )}
                        </Option>
                        <Option
                          value="reviewed_by_pharmacy_manufacturer"
                          disabled
                        >
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Reviewed at the pharmacy"
                          )}
                        </Option>
                        <Option
                          value="validated_by_the_research_coordinator"
                          disabled
                        >
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Validated by the research coordinator"
                          )}
                        </Option>
                        <Option value="in_transit_pharmacy_fridge" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:In transit to the fridge"
                          )}
                        </Option>
                        <Option value="quarantined_by_manufacturer" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Quarantined - at manufacturer"
                          )}
                        </Option>
                        <Option value="quarantined_by_depot" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Quarantined - at depot"
                          )}
                        </Option>
                        <Option value="quarantined_by_pharmacy" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Quarantined - at pharmacy"
                          )}
                        </Option>
                        <Option value="quarantined_by_fridge" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Quarantined - at fridge"
                          )}
                        </Option>
                        <Option value="received_by_fridge" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Received by the fridge"
                          )}
                        </Option>
                        <Option value="available" disabled>
                          {this.props.i18n.t("Available")}
                        </Option>
                        <Option value="assigned_to_a_patient" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Assigned to a patient"
                          )}
                        </Option>
                        <Option value="allocated" disabled>
                          {this.props.i18n.t("NamespaceDrugForm:Allocated")}
                        </Option>
                        <Option value="no_longer_available_offline" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:No longer available / damaged"
                          )}
                        </Option>
                        <Option value="reviewed_by_manufacturer" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Reviewed - at manufacturer"
                          )}
                        </Option>
                        <Option value="reviewed_by_depot" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Reviewed - at drug depot"
                          )}
                        </Option>
                        <Option value="reviewed_by_fridge" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Reviewed - at fridge"
                          )}
                        </Option>
                        <Option value="lost" disabled>
                          {this.props.i18n.t("NamespaceDrugForm:Lost")}
                        </Option>
                        <Option value="returned_destroyed" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Returned / Destroyed"
                          )}
                        </Option>
                        <Option value="sent_back_to_manufacturer" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Sent back to the Manufacturer"
                          )}
                        </Option>
                        <Option value="sent_back_to_depot" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Sent back to the Depot"
                          )}
                        </Option>
                        <Option value="sent_back_to_pharmacy" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Sent back to the Pharmacy"
                          )}
                        </Option>
                        <Option value="sent_back_to_fridge" disabled>
                          {this.props.i18n.t(
                            "NamespaceDrugForm:Sent back to the Fridge"
                          )}
                        </Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceDrugForm:Units returned")}</b>
                  <Form.Item>
                    <Input
                      disabled={true}
                      value={get(this.props, "units_returned", "0")}
                    />
                  </Form.Item>
                </label>
              </Col>
              {/* <Col span={12}>
              <label>
                <b>Tracking #</b>
                <Form.Item>
                  <Input disabled={true} value={get(this.props, 'tracking')} />
                </Form.Item>
              </label>
            </Col> */}
              {/* <Col span={18}>
              <label>
                <b>Expiry date</b>
                <Form.Item>
                  <div style={{ display: 'flex', alignItems: 'center', width: '340px' }}>
                    {getFieldDecorator('expiry_date', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: this.props.expiry_date ? moment.utc(this.props.expiry_date).tz(this.props.userTimezone || 'UTC') : moment.utc(new Date()).tz(this.props.userTimezone || 'UTC')
                    })(
                      <DatePicker
                        disabled={!isEditable || !drugCreatePermission}
                        format='YYYY/MM/DD'
                      />,
                    )}

                    <span style={{width: '35px'}}>
                      &nbsp;{this.props.userShortTimezone || 'UTC'}
                    </span>
                  </div>
                </Form.Item>
              </label>
            </Col> */}
              <Col span={24}>
                <label>
                  <b>{this.props.i18n.t("Comments")}</b>
                  <Form.Item>
                    {getFieldDecorator("comments", {
                      initialValue: get(this.props, "comments"),
                    })(<Input.TextArea />)}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          )}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  drugAccessPermissionDrugManagement: getDrugAccessPermissionDrugManagement(state),
  drugCreatePermission: getDrugCreatePermission(state),
  drugUpdatePermission: getDrugUpdatePermission(state),
  drugAllowEditItem: getDrugAllowEditItem(state),
  drugPackageInfoEditInDrugManagement: getDrugPackageInfoEditInDrugManagement(state),
  getDrugExpiryDateEditPermission: getDrugExpiryDateEditPermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "drug" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DrugForm))
);



// WEBPACK FOOTER //
// ./src/components/DrugForm/DrugForm.js